export default Object.freeze({
  SCREEN: 'screen',
  OPERATOR: 'operator',
  VIEWER: 'viewer',
  ADMIN: 'admin',
  EDITOR: 'editor',
  PRESIDENT: 'president'
})



// WEBPACK FOOTER //
// ./src/enums/role.js